import { VERSION } from '@/config/version';
import { ChangelogViewer } from '@/components/ChangelogViewer';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function VersionBadge() {
  return (
    <div className="justify-between- flex items-center gap-2 px-2 py-1">
      <span className="text-muted-foreground text-xs">{VERSION}</span>
      <ChangelogViewer
        trigger={
          <Button
            variant="ghost"
            size="icon"
            className="text-muted-foreground hover:text-foreground h-5 w-5"
          >
            <Info className="h-3 w-3" />
          </Button>
        }
      />
    </div>
  );
}
